import {
  getItem,
  removeItem,
  addItemFromObject,
  clearStorage,
} from "./LocalStorageService";
import { jwtDecode } from "jwt-decode";

import api from "../api.js";
import DownloadFileService from "./UploadFileService";
import FileService from "./FileService";
import ReportFaturaService from "./ReportFaturaService";

/* ======================
   CONSTANTES
====================== */

export const KEY_USER = "_logged_user";
export const SESSION_EXPIRED = "_session_expired";

/* ======================
   TOKEN / SESSION
====================== */

export const setSessionActive = () => {
  addItemFromObject(SESSION_EXPIRED, false);
};

export const setSessionExpired = () => {
  addItemFromObject(SESSION_EXPIRED, true);
};

export const isSessionExpired = () => {
  const raw = getItem(SESSION_EXPIRED);
  return raw === true || raw === "true";
};

/* ======================
   LOGIN / LOGOUT
====================== */

export const addUserAuthenticate = (json) => {
  addItemFromObject(KEY_USER, json);
  registerToken(json.token);
};

export const removeUserAuthenticate = () => {
  removeItem(KEY_USER);
};

export const clearStoragePortal = () => {
  clearStorage();
};

/* ======================
   TOKEN REGISTRATION
====================== */

const registerToken = (token) => {
  api.registerSession(token);
  DownloadFileService.registerSession(token);
  FileService.registerSession(token);
  ReportFaturaService.registerSession(token);
};

export const restoreSession = () => {
  const user = getStoredUser();
  if (user?.token) {
    registerToken(user.token);
  }
};

/* ======================
   STORAGE / JWT
====================== */

export const getStoredUser = () => {
  let user = getItem(KEY_USER);
  if (!user) return null;

  if (typeof user === "string") {
    try {
      user = JSON.parse(user);
    } catch {
      return null;
    }
  }

  return user?.token ? user : null;
};

export const getDecodedToken = () => {
  const user = getStoredUser();
  if (!user?.token) return null;

  try {
    return jwtDecode(user.token);
  } catch {
    return null;
  }
};

export const isUserAuthenticate = () => {
  const user = getStoredUser();
  if (!user) return null;

  const decoded = getDecodedToken();
  if (!decoded?.exp) return null;

  const expired = Date.now() >= decoded.exp * 1000;
  return expired ? null : user;
};

/* ======================
   SIMPLE GETTERS
====================== */

export const getUsername = () => {
  const decoded = getDecodedToken();
  return decoded?.username ?? null;
};

export const getCodEmpUser = () => {
  const decoded = getDecodedToken();
  return decoded?.codEmpresa ?? null;
};

export const isAdmin = () => {
  const decoded = getDecodedToken();
  return decoded?.admin === true;
};

export const getRoles = () => {
  const decoded = getDecodedToken();
  const roles =
    decoded?.roles || decoded?.authorities || decoded?.permissoes || [];
  return Array.isArray(roles) ? roles : [];
};

export const getFiliais = () => {
    const decoded = getDecodedToken();
    return decoded?.filiais ?? [];
};

/* ======================
   LOGIN HELPER
====================== */

export const verifyFirstLogin = (json) => {
  const decoded = jwtDecode(json.token);

  addUserAuthenticate(json);

  return {
    isReset: decoded?.reset === true,
    isAdmin: decoded?.admin === true,
  };
};

export const hasRole = (role) => {
  const roles = getRoles();
  return roles.includes(role);
};

export const hasAnyRole = (roles = []) => {
  const userRoles = getRoles();
  return roles.some((r) => userRoles.includes(r));
};